import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Import the functions you need from the SDKs you need
import firebase from "firebase/app";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC3H2SqOmfk5_ubxEBPYAtDEWpNtg7JI2A",
    authDomain: "askvikdevelopmentwebsite.firebaseapp.com",
    projectId: "askvikdevelopmentwebsite",
    storageBucket: "askvikdevelopmentwebsite.appspot.com",
    messagingSenderId: "7363249765",
    appId: "1:7363249765:web:c4a08d4df3d8d0c338a88c",
    measurementId: "G-ZX3XTX8NKQ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

reportWebVitals();
